import { useTranslation } from 'react-i18next';

import type { GiftCardStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONE: Record<GiftCardStatus, string> = {
  active: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  disabled: 'bg-destructive/10 text-destructive border-transparent',
  expired: 'border-border text-muted-foreground',
  depleted: 'border-border text-muted-foreground',
};

export function GiftCardStatusBadge({
  status,
  className,
}: {
  status: GiftCardStatus;
  className?: string;
}) {
  const { t } = useTranslation('giftCards');
  return (
    <Badge variant="outline" className={cn(TONE[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
